import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "status", "input", "button"]

  async save(event) {
    event.preventDefault()
    if (this.saving) return
    const form = event.currentTarget
    if (!form.reportValidity()) return

    this.saving = true
    this.buttonTarget.disabled = true
    this.inputTarget.readOnly = true
    this.statusTarget.textContent = "Saving…"
    try {
      const response = await fetch(form.action, {
        method: "POST",
        credentials: "same-origin",
        headers: { Accept: "application/json", "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || "" },
        body: new FormData(form)
      })
      const payload = await response.json()
      if (!response.ok) throw new Error(payload.error || "Note could not be saved. Please try again.")
      if (typeof payload.html !== "string") throw new Error("Unexpected response. Refresh to check whether your note was saved.")
      this.listTarget.innerHTML = payload.html
      this.inputTarget.value = ""
      this.statusTarget.textContent = payload.message
    } catch (error) {
      this.statusTarget.textContent = error instanceof TypeError || error instanceof SyntaxError
        ? "Could not confirm the save. Your note is still here; check the connection and refresh before retrying."
        : error.message
    } finally {
      this.saving = false
      this.buttonTarget.disabled = false
      this.inputTarget.readOnly = false
    }
  }
}
